import {
  GET_COURSES_SUCCESS,
  GET_COURSES_ERROR,
  GET_MODULES_SUCCESS,
  GET_MODULES_ERROR,
  GET_SPECIFIC_MODULE_SUCCESS,
  GET_SPECIFIC_MODULE_ERROR,
  GET_SPECIFIC_COURSE_SUCCESS,
  GET_SPECIFIC_COURSE_ERROR,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  ADD_COURSE_SUCCESS,
  ADD_COURSE_ERROR,
  DELETE_COURSE_SUCCESS,
  DELETE_COURSE_ERROR,
  ADD_MODULE_SUCCESS,
  ADD_MODULE_ERROR,
  DELETE_MODULE_SUCCESS,
  DELETE_MODULE_ERROR,
  UPDATE_MODULE_SUCCESS,
  UPDATE_MODULE_ERROR,
  UPDATE_COURSE_SUCCESS,
  UPDATE_COURSE_ERROR
} from "../actionTypes/authActionTypes";
import apiCall from "../../helpers/apiCall";
import errorProcessor from "../../helpers/errorProcessor";
import { decode } from "../../utils/tokenDecoder";


const token = localStorage.getItem("x-auth-token");
const dataFromToken=decode(token);

export const viewAllCoursesAction = () => async (dispatch) => {
  try {
    const user = !token ? "student" : !decode(token).role ? "student" : decode(token).role;
    const allCoursesReseponse = await apiCall.get("/courses/" + user);
    dispatch({
      type: GET_COURSES_SUCCESS,
      payload: allCoursesReseponse.data,
    });
  } catch (error) {
    const err = errorProcessor(error);
    dispatch({
      type: GET_COURSES_ERROR,
      payload: error.response.data || err,
    });
  }
};



export const viewModulesAction = (courseName) => async (dispatch) => {
  try {
    const allModulesReseponse = await apiCall.get(
      `/courses/${courseName}/modules`
    );
    dispatch({
      type: GET_MODULES_SUCCESS,
      payload: allModulesReseponse.data,
    });
  } catch (error) {
    const err = errorProcessor(error);
    dispatch({
      type: GET_MODULES_ERROR,
      payload: error.response.data || err,
    });
  }
};

export const viewModulesActionList = (courseName) => async (dispatch) => {
  try {
    const allModulesReseponse = await apiCall.get(
      `/courses/${courseName}/modules/all`
    );
    dispatch({
      type: GET_MODULES_SUCCESS,
      payload: allModulesReseponse.data,
    });
  } catch (error) {
    const err = errorProcessor(error);
    dispatch({
      type: GET_MODULES_ERROR,
      payload: error.response.data || err,
    });
  }
};

export const viewSpecificModuleAction = (courseName, moduleName) => async (
  dispatch
) => {
  try {
    const specificModuleReseponse = await apiCall.get(
      `/courses/${courseName}/modules/${moduleName}`
    );
    dispatch({
      type: GET_SPECIFIC_MODULE_SUCCESS,
      payload: specificModuleReseponse.data,
    });
  } catch (error) {
    const err = errorProcessor(error);
    dispatch({
      type: GET_SPECIFIC_MODULE_ERROR,
      payload: error.response.data || err,
    });
  }
};


// export const viewSpecificCourseAction = (courseName) => async (
//   dispatch
// ) => {
//   try {
//     const specificCourseReseponse = await apiCall.get(
//       `/courses/${courseName}`
//     );
//     dispatch({
//       type: GET_SPECIFIC_COURSE_SUCCESS,
//       payload: specificCourseReseponse.data,
//     });
//   } catch (error) {
//     const err = errorProcessor(error);
//     dispatch({
//       type: GET_SPECIFIC_COURSE_ERROR,
//       payload: error.response.data || err,
//     });
//   }
// };

export const viewSpecificCourse=async(courseName)=>{
  try{
    const res = await apiCall.get(`/courses/one/${courseName}`);
    // console.log("<><><><><><",res.data);
    return res.data.data;

  }catch(error){
    console.log(error);
  }
}

export const addCourseAction = (payload) => async (dispatch) => {
  try {
    const data = { ...payload, inspirations: [payload.insp1, payload.insp2, payload.insp3] }
    const specificModuleReseponse = await apiCall.post(
      `/courses/add`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": token,
        },
      }
    );
    dispatch({
      type: ADD_COURSE_SUCCESS,
      payload: specificModuleReseponse.data,
    });
  } catch (error) {
    const err = errorProcessor(error);
    dispatch({
      type: ADD_COURSE_ERROR,
      payload: error.response.data || err,
    });
  }
};


export const deleteCourseAction = (courseName) => async (dispatch) => {
  try {
    const specificModuleReseponse = await apiCall.delete(
      `/courses/${courseName}`,
      {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": token,
        },
      }
    );
    dispatch({
      type: DELETE_COURSE_SUCCESS,
      payload: specificModuleReseponse.data,
    });
  } catch (error) {
    const err = errorProcessor(error);
    dispatch({
      type: DELETE_COURSE_ERROR,
      payload: error.response.data || err,
    });
  }
};

export const addModuleAction = (payload) => async (dispatch) => {
  try {
    console.log(payload)
    const { courseName } = payload;
    const addModuleReseponse = await apiCall.post(
      `/courses/${courseName}/new-module`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": token,
        },
      }
    );
    dispatch({
      type: ADD_MODULE_SUCCESS,
      payload: addModuleReseponse.data,
    });
  } catch (error) {
    const err = errorProcessor(error);
    dispatch({
      type: ADD_MODULE_ERROR,
      payload: error.response.data || err,
    });
  }
};

export const deleteModuleAction = ({ courseName, moduleName }) => async (dispatch) => {
  try {
    const specificModuleReseponse = await apiCall.delete(
      `/courses/${courseName}/modules/${moduleName}`,
      {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": token,
        },
      }
    );
    dispatch({
      type: DELETE_MODULE_SUCCESS,
      payload: specificModuleReseponse.data,
    });
  } catch (error) {
    const err = errorProcessor(error);
    dispatch({
      type: DELETE_MODULE_ERROR,
      payload: error.response.data || err,
    });
  }
};

export const loginActionAction = (loginData) => async (dispatch) => {
  try {
    const loginResponse = await apiCall.post(`/auth/login`, loginData);
    dispatch({
      type: LOGIN_SUCCESS,
      payload: loginResponse.data,
    });
  } catch (error) {
    const err = errorProcessor(error);
    dispatch({
      type: LOGIN_ERROR,
      payload: error.response.data || err,
    });
  }
};

export const updateModuleAction = (payload) => async (dispatch) => {
  try {
    const { courseName, oldModuleName } = payload;
    const updateModuleReseponse = await apiCall.patch(
      `/courses/${courseName}/modules/${oldModuleName}`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": token,
        },
      }
    );
    dispatch({
      type: UPDATE_MODULE_SUCCESS,
      payload: updateModuleReseponse.data,
    });
    console.log(">>>>>>>>>>>>>" + payload);
  } catch (error) {
    const err = errorProcessor(error);
    dispatch({
      type: UPDATE_MODULE_ERROR,
      payload: error.response.data || err,
    });
  }
};

export const updateCourseAction = (payload) => async (dispatch) => {
  try {
    const { oldName } = payload;

    let data = {
      name: payload.courseName,
      image: payload.image || "https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg",
      inspirations: [payload.insp1, payload.insp2, payload.insp3],
      duration: payload.duration || 0,
      description: payload.courseDescription,
      is_visible: payload.isVisible,
      updatedAt: Date.now()

    }

    const updateModuleReseponse = await apiCall.patch(
      `/courses/${oldName}`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": token,
        },
      }
    );
    dispatch({
      type: UPDATE_COURSE_SUCCESS,
      payload: updateModuleReseponse.data,
    });
  } catch (error) {
    const err = errorProcessor(error);
    dispatch({
      type: UPDATE_COURSE_ERROR,
      payload: error.response.data || err,
    });
  }
};
